"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateInsurancePaymentOptions = void 0;
const common_1 = require("../../common");
const common_2 = require("../common");
const insurance_options_validator_1 = require("./insurance-options-validator");
const rates_1 = require("./rates");
const defaults_1 = require("./rates/defaults");
const rate_payment_option_factory_1 = require("./rates/rate-payment-option-factory");
const standard_factors_1 = require("./standard-factors");
function calculateSinglePaymentOption(options) {
    const faceAmount = options.amount * standard_factors_1.SINGLE_PAY_FACE_AMOUNT_FACTOR;
    return [
        {
            years: 1,
            numberOfPayments: common_2.MONTHS_IN_YEAR,
            premium: options.amount,
            amountOfFirstPayment: options.amount,
            faceAmount: common_2.roundPayment(faceAmount),
            paymentMode: common_1.PaymentMode.Single,
            paymentPeriod: null,
        },
    ];
}
function calculateMultiPaymentOption(options) {
    const rates = options.rates || defaults_1.DEFAULT_RATES;
    const ageReplacementRules = options.ageReplacementRules || defaults_1.DEFAULT_AGE_REPLACEMENT_RULES;
    const rate = rates_1.getRateForInsurance(options, rates, ageReplacementRules);
    if (!rate) {
        return [];
    }
    const calculatedRate = rates_1.calculateRate(rate, options);
    const rateOverrides = options.rateOverrides || defaults_1.DEFAULT_RATE_OVERRIDES;
    const overrideRate = rates_1.applyOverridesToRate(options, calculatedRate, rateOverrides);
    return rate_payment_option_factory_1.createPaymentOptionsFromRate(overrideRate, options);
}
function calculateInsurancePaymentOptions(options) {
    const validation = insurance_options_validator_1.validateInsuranceOptions(options);
    if (!validation.isValid) {
        return Object.assign(Object.assign({}, validation), { paymentOptions: [] });
    }
    if (options.paymentMode === common_1.PaymentMode.Single || options.incapacitatedRates) {
        return {
            isValid: true,
            errors: [],
            paymentOptions: calculateSinglePaymentOption(options),
        };
    }
    return {
        isValid: true,
        errors: [],
        paymentOptions: calculateMultiPaymentOption(options),
    };
}
exports.calculateInsurancePaymentOptions = calculateInsurancePaymentOptions;
//# sourceMappingURL=insurance-payment-calculator.js.map